<template>
    <div class="page-content-wrapper">
        <div v-if="getCategories.length===0 || !getRecipes">
            <loading></loading>
        </div>
        <div v-else
             class="content">
            <div class="container-fluid container-fixed-lg">
                <div class="row p-3">
                    <div class="col-lg-12">
                        <h2 class="text-dag">{{ category }}</h2>
                        <div class="receptdiv">
                            <p class="sectiontitle2 text-muted">recepten</p>
                        </div>
                    </div>
                </div>

                <div class="row p-3">
                    <div v-for="recipe in getRecipes"
                         class="col-lg-3 m-b-10">
                        <div class="card no-border widget-loader-circle no-padding rounded h-100">
                            <div class="card-header dag-box">
                            </div>
                            <div class="card-body text-center p-t-20 p-b-30">
                                <router-link class="card-link-24 text-dag"
                                             :to="{ name: 'recipe', params: { recipe_id: recipe.Id} }">
                                    <div class="card-icon">
                                        <img :src="require(`@/assets/img/Food icons/${recipe.Image}`)" alt="food" width="100"/>
                                    </div>
                                    <div class="card-link">
                                        {{ recipe.Title }}
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'
  import Loading from '../utilities/Loading.vue';

  export default {
    data() {
      return {
        categoryId: this.$route.params.cat_id,
      }
    },
    components: {Loading},
    computed: {
      ...mapGetters([
        'getRecipes',
        'getCategories',
      ]),
      category () {
        return this.getCategories.find((obj => obj.Id === this.categoryId)).Text
      }
    },
    methods: {
      ...mapActions([
        'loadCategoryRecipes',
      ]),
    },
    created() {
      this.loadCategoryRecipes(this.categoryId)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/recipes/Recipes.vue